export const urlConfig = {
  // baseUrl: "https://aics.ccom.com.cn", //测试平台
  baseUrl: "https://ai.ccom.com.cn", //正式平台
};
// export const urlConfig = {
//     baseUrl: "http://localhost:8763",
// }
